import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-product-tab-title',
  templateUrl: './product-tab-title.component.html',
  styleUrls: ['./product-tab-title.component.sass']
})
export class ProductTabTitleComponent {
  @Input() public title: string;
  @Input() public badgeCount: number;
}
